import { FC, Dispatch, SetStateAction, ChangeEvent } from 'react'
import { ApplicantData } from '../../../dtos/applicationData'
import { FlexDiv } from 'src/components/application/formComponents/styles'
import {
  DefaultTitle,
  DefaultSubtitle,
  FormContainer,
  SuccessInputTextHelper
} from '../../../components/application/defaultComponents'
import ReminderCard from '../../../components/basic/ReminderCard'
import { useApplication } from '../../../context/application'
import StandardInput from '../../../components/basic/StandardInput'
import { IoIosCheckmarkCircle } from 'react-icons/io'

interface ApplicantEmailProps {
  applicantData: Partial<ApplicantData>;
  setApplicantData: Dispatch<SetStateAction<Partial<ApplicantData>>>;
  confirmEmail: string;
  setConfirmEmail: Dispatch<SetStateAction<string>>;
  isEmailVerificationValid: boolean | undefined;
  setIsEmailVerificationValid: Dispatch<SetStateAction<boolean | undefined>>;
  emailValidation: {
    active: boolean;
    title: string;
    subtitle: string;
  }
}

const ApplicantEmail: FC<ApplicantEmailProps> = ({
  applicantData,
  setApplicantData,
  confirmEmail,
  setConfirmEmail,
  isEmailVerificationValid,
  setIsEmailVerificationValid,
  emailValidation
}) => {
  const { application: { applicant } } = useApplication()

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    setApplicantData(prev => ({ ...prev, [name]: value }))
  }

  return (
    <>
      <DefaultTitle>Hi {applicant?.firstName?.split(' ')[0]}! Now, let’s get your email.</DefaultTitle>
      <DefaultSubtitle>
        We use this information to save your form and contact you <br />
        if you need help.
      </DefaultSubtitle>
      <FormContainer>
        <StandardInput
          type="email"
          label="Email Address"
          name="emailAddress"
          value={applicantData.emailAddress}
          onChange={handleInputChange}
        />
        <FlexDiv dir="column">
          <StandardInput
            type="email"
            label="Confirm Email Address"
            value={confirmEmail}
            onChange={e => {
              setConfirmEmail(e.target.value)
              if (e.target.value === '')
                setIsEmailVerificationValid(false)
            }}
            isIncorrect={isEmailVerificationValid === false}
            errorMessage={isEmailVerificationValid === false ? 'The emails do not match.' : ''}
          />
          {isEmailVerificationValid ? (
            <SuccessInputTextHelper>
              <IoIosCheckmarkCircle />
              Emails match
            </SuccessInputTextHelper>
          ) : null}
        </FlexDiv>
        {emailValidation.active === true ? (
          <ReminderCard
            icon='warning'
            title={emailValidation.title}
          >
            {emailValidation.subtitle}
          </ReminderCard>
        ) : (
          <ReminderCard
            icon='bulb'
            withLeftBar
            title='We contact you via this email'
          >
            This address will be used to receive communication about your application and can be used to return to the application later.
          </ReminderCard>
        )}
      </FormContainer>
    </>
  )
}

export default ApplicantEmail